import { ChangeDetectorRef, Component, EventEmitter, inject, Inject, Input, LOCALE_ID, OnDestroy, OnInit, Output, ViewChild, ViewRef } from '@angular/core';
import { CellClickEvent, CellCloseEvent, CreateFormGroupArgs, GridComponent, GridItem } from '@progress/kendo-angular-grid';
import { CompositeFilterDescriptor, FilterDescriptor, process, toODataString } from "@progress/kendo-data-query";
import { FormBuilder, FormGroup } from '@angular/forms';
import { IColumns } from 'bi-interfaces/lib/interfaces/IColumns.interface';
import { IColumnConfig } from 'bi-interfaces';
import { IDataSource } from 'bi-interfaces/lib/interfaces/IDataSource';
import { IChangeset } from 'bi-interfaces/lib/interfaces/IChangeset';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';
import { BehaviorSubject, Observable, Subject, Subscription, merge, pipe } from 'rxjs';
import { filter, mapTo, switchMap, take, takeUntil, tap } from 'rxjs/operators';
import { LoggerService } from '../../services/logger.service';
import { DataTypes as DataType } from 'bi-interfaces';
import { MessageService } from '@progress/kendo-angular-l10n';

import { PageChangeEvent } from '@progress/kendo-angular-pager';

import { BIModulesService } from '../../bi-modules.service';
import { GetValuePipe } from '../../pipes/get-value.pipe';
import { NegativeValueTransformPipe } from '../../pipes/negative-value-transform.pipe';

import { TranslateService } from '@ngx-translate/core';
import { ErrorDetailsService } from '../../services/error-details.service';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';
import { Router } from '@angular/router';
import { IExportSettings } from 'bi-interfaces';
import { UiProfileService } from '../../services/ui-profile.service';
import { CreateDialog } from '../bi-dialog/createDialog.service';
import { BIGridColumnCustomizerComponent } from '../bi-column-customizer/bi-column-customizer.component';
import { DatePipe } from '@angular/common';
import { IPopup } from 'bi-interfaces';




enum StatusAction {
  ADD = "Add",
  UPDATE = "Update",
  NOP = "NOP",
  Delete = "Delete"
}
export enum BeforeAction {
  NoSaveImp = "NoSaveImp",
  NoDeleteImp = "NoDeleteImp"

}
class JSONPatchReq {
  op!: string;
  path!: string;
  value: any
}
@Component({
  selector: 'BI-Grid',
  templateUrl: './bi-grid.component.html',
  styleUrls: ['./bi-grid.component.scss']
})
export class BIGridComponent implements OnInit, OnDestroy, IGrid, IExportSettings {
  @Input() public DataService!: IDataSource;
  @Input() public changeSet!: IChangeset;
  @Input() Columns!: IColumns[];
  @Input() GridName!: string;
  @Input() refGrid!: string;
  @Input() DomID!: string;
  @Input() HasPaging!: boolean;
  @Input() HasSelectAll!: boolean;
  @Input() HasFullHeight!: boolean;
  @Input() HasExport!: boolean;
  @Input() ExportFileName!: string;
  @Input() colors: any;
  @Output() CellClick = new EventEmitter<CellClickEvent>();
  @Output() CellClose = new EventEmitter<CellCloseEvent>();
  @Output() RowChange = new EventEmitter<any>();
  @Output() RowChangeMasterGridChangeDetails = new EventEmitter<any>();
  @Output() OnLoadData = new EventEmitter<any>();
  @Output() BeforeAddRow = new EventEmitter<any>();
  @Output() OnAddRow = new EventEmitter<any>();
  @Output() AfterAddRow = new EventEmitter<any>();
  @Output() OnCloseRow = new EventEmitter<any>();
  @Output() AfterSave = new EventEmitter<any>();
  @Output() AfterAdd = new EventEmitter<any>();
  @Output() AfterCancel = new EventEmitter<any>();
  @Output() SortChanges = new EventEmitter<any>();
  @Output() ChangeAllCheckBoxes = new EventEmitter<any>();
  @Output() beforeCheckAll = new EventEmitter<any>();
  @Output() BeforeDeleteRow = new EventEmitter<any>();
  @ViewChild("Grid") Mygrid!: GridComponent;
  @ViewChild("customizeColumnsDialog") customizeColumnsDialogTemplate!: any;
  @ViewChild("openPopUpDialog") openPopUpDialog!: IPopup;
  customizeColumnsDialog = this._dialog() as CreateDialog;
  isCustomizeColumnsVisible: boolean = false;
  public statusAction: StatusAction = StatusAction.NOP;
  AllowSave!: Subject<boolean>;
  AllowDelete!: Subject<boolean>;
  AllowAdd!: Subject<boolean>;
  form: any = {};
  DefaultValue: any = {};
  CurrentSelectRow!: FormGroup;
  rowCol!: IColumns;
  Status!: IColumns;
  formGroups: FormGroup[] = []
  GridData!: any;
  public mySelection: number[] = [0];
  rowIndex!: any;
  dataItem: any = {};
  dataItemReset!: any;
  data: any;
  newForm: any = {};
  prevRow: any = -1;
  totalDataLength: number = 0;
  RowID!: string;
  RowIdentifier: string = 'R_WID';
  ChangeSet_Status: string = 'ChangeSet_Status';
  GridDataSubscription!: Subscription;
  RowSubscription!: Subscription;
  StopDeleteSubscription!: Subscription;
  public StopAddSubscription!: Subscription;
  StopSaveSubscription!: Subscription;
  DeleteSubscription!: Subscription;
  AddSubscription!: Subscription;
  EditSaveSubscription!: Subscription;
  filter: any;
  @Input() height!: number;

  GridID!: string;
  RowCount: number = 0;
  Precision!:  string | null;
  checkboxColumnIndexLastChanged!: number;
  DefaultPrecision = '1.2-2'
  private userProfileFilledSub: Subscription = new Subscription();

  private datePipe = inject(DatePipe);
  IsHeader:boolean=true;

  public GetNewRowID(): string {
    const formattedDateTime: string = `${Math.random()}`;
    return formattedDateTime;
  }
  getFormGroup(RowID: string | any): FormGroup {
    return this.formGroups.filter(f => f.controls[this.RowIdentifier].value === RowID)[0];
  }
  constructor(
    @Inject('CreateDialog') public _dialog: any,
    @Inject(LOCALE_ID) public localeId: string,
    public intlService: IntlService,
    public formBuilder: FormBuilder,
    public loggerService: LoggerService,
    public biService: BIModulesService,
    public messages: MessageService,
    public getValuePipe: GetValuePipe,
    public translateService: TranslateService,
    private cd: ChangeDetectorRef,
    public errorDetailsService: ErrorDetailsService,
    private router: Router,
    private uiProfileService: UiProfileService
  ) {
    this.localeId = this.biService.getLocal();
    this.HasPaging = true;
    (<CldrIntlService>this.intlService).localeId = this.biService.getLocal();
    this.IsHeader=true;
  }

  ngOnInit() {
    this.DataService.Columns.forEach((res: any) => this.form[res.Name] = [null]);
    this.form[this.RowIdentifier] = [''];
    this.form[this.ChangeSet_Status] = [''];
    this.handleFormGroup();
    setTimeout(() => {
      this.GetGridData();
    });
    //this.read();
    this.createFormGroup = this.createFormGroup.bind(this);// no need for this line
    this.AllowSave = new Subject<boolean>();
    this.AllowSave.next(true);
    this.AllowDelete = new Subject<boolean>();
    this.AllowDelete.next(true);
    this.AllowAdd = new Subject<boolean>();
    this.AllowAdd.next(true);
    this.messages.notify(this.biService.getDir());
    this.PushChangesArr();
    this.GridID = `${Math.random()}`;
    this.Precision  = localStorage.getItem("Precision");
    this.DefaultPrecision =  `1.${this.Precision}-${this.Precision}`
    // this.SubscribeForColumnConfigs();
    if(this.uiProfileService.IsUserUIProfileFilled)
      this.ApplyUserColumnsConfigs()
    else{
      this.userProfileFilledSub = this.uiProfileService.UserUIProfileFilled$
      .subscribe(
        _ =>{
          this.ApplyUserColumnsConfigs();
          this.userProfileFilledSub.unsubscribe();
        });
    }
  }
 
  private ApplyUserColumnsConfigs(){
    const configs = this.uiProfileService.UserUIProfile.BS_GridColumnConfigs.filter(config => config.GridId == this.DomID)
    this.Columns.forEach(gridCol => {
      let colConfig: IColumnConfig| undefined = configs.find((colConfig: IColumnConfig) => gridCol.Name == colConfig.Name)
      gridCol.Order = colConfig?.Order;
      if(colConfig){
        if(gridCol.IsVisible && !colConfig.IsVisible){gridCol.IsHiddenByUser = true; gridCol.IsVisible = false}
        gridCol.DataBaseId = colConfig.Id;
      }
    });
    
    this.Columns.sort((a, b) => {
      if (a.Order === null && b.Order === null) return 0;
      if (a.Order === null) return 1;
      if (b.Order === null) return -1;
      return (a.Order ?? 0) - (b.Order ?? 0);
    })
  }

  public ReAssignColumns() {
    this.form = {}
    this.DataService.Columns.forEach((res: any) => this.form[res.Name] = [null]);
    this.form[this.RowIdentifier] = [''];
    this.form[this.ChangeSet_Status] = [''];


    this.handleFormGroup();

    this.createFormGroup = this.createFormGroup.bind(this);// no need for this line
    this.Mygrid.data = this.GridData;
  }

  PushChangesArr() {
    this.changeSet.changesetArr.push({ Grid: this })
  }

  public read() {
    if (!this.filter) {
      this.filter = '';
      if (this.DataService.state.sort)
        this.filter += toODataString({ "sort": this.DataService.state.sort });
    }
    this.filter = this.filter.replace("$skip=0", "");
    let filterToRead = (this.filter ?? '');
    if(this.HasPaging)
      {
          filterToRead += `&$skip= ${this.DataService.state.skip}&$top=${this.DataService.state.take}&$count=true`;
      }

    this.DataService.read(filterToRead);
  }
  handleFormGroup() {
    this.rowCol = {
      Name: this.RowIdentifier, IsVisible: false, DefaultValue: null, DisplayName: this.RowIdentifier, DataType: DataType.Text, IsEditable: false,
      IsFilterable: false, controlType: "text", viewCellStyle: "", DomID: "", Validators: null
    }
    this.Status = {
      Name: this.ChangeSet_Status, IsVisible: false, DefaultValue: null, DisplayName: this.ChangeSet_Status, DataType: DataType.Text, IsEditable: false,
      IsFilterable: false, controlType: "text", viewCellStyle: "", DomID: "", Validators: null
    }
    this.Columns.push(this.rowCol);
    this.Columns.push(this.Status);
    this.Columns.forEach(res => {
      if (this.form.hasOwnProperty(res.Name)) this.form[res.Name] = [{ value: res.DefaultValue, disabled: !res.IsEditable }, res.Validators];
      this.DefaultValue[res.Name] = res.DefaultValue;
    });
  }

  CompareBetweenTwoDate(res: any, dataItem: any) {
    let FormGroupDate = res.controls[this.DataService.Key2].value;
    FormGroupDate.setHours(0, 0, 0, 0);
    let dataItemDate = new Date(dataItem[this.DataService.Key2]);
    dataItemDate.setHours(0, 0, 0, 0);
    return FormGroupDate.toISOString() == dataItemDate.toISOString()
  }

  changeCheckBox(event: any, Name: string, dataItem: any, rowIndex: any, columnIndex: any) {
    let oldRowID=this.RowID;let newRowID=dataItem?.[this.RowIdentifier];
    this.RowID = this.CheckPendingChange() ? this.RowID : dataItem?.[this.RowIdentifier];
    this.checkboxColumnIndexLastChanged = columnIndex;
    this.CurrentSelectRow = this.getFormGroup(this.RowID ?? dataItem?.[this.RowIdentifier]);
    if (!this.CheckPendingChange() || (this.CurrentSelectRow.dirty && this.CurrentSelectRow.getRawValue()[this.RowIdentifier] === dataItem[this.RowIdentifier])) {
      if (this.CurrentSelectRow?.get(this.ChangeSet_Status)?.getRawValue() !== StatusAction.ADD) {
        this.resetRowIndex = rowIndex;

        this.CurrentSelectRow.get(this.ChangeSet_Status)?.patchValue(StatusAction.UPDATE);
        this.CurrentSelectRow.markAsDirty();
        this.Mygrid.editCell(
          rowIndex,
          columnIndex, this.CurrentSelectRow
        );
        if(oldRowID!=newRowID)this.RowChange.emit();
      }
      else {
        this.CurrentSelectRow.get(this.ChangeSet_Status)?.patchValue(StatusAction.ADD);
      }
      //change in formGroup
      let formGroupconditions: ((res: any) => boolean)[] = [];
      if (this.getTypeFilter(this.DataService.Key) === DataType.Date) {
        formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
      } else {
        formGroupconditions.push((res: any) => res.controls[this.DataService.Key].value === dataItem[this.DataService.Key]);
      }
      if (this.DataService.Key2) {
        if (this.getTypeFilter(this.DataService.Key2) === DataType.Date) {
          formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
        } else {
          formGroupconditions.push((res: any) => res.controls[this.DataService.Key2].value === dataItem[this.DataService.Key2]);
        }
      }
      if (this.DataService.Key3) {
        if (this.getTypeFilter(this.DataService.Key3) === DataType.Date) {
          formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
        } else {
          formGroupconditions.push((res: any) => res.controls[this.DataService.Key3].value === dataItem[this.DataService.Key3]);
        }
      }
      if (this.DataService.Key4) {
        if (this.getTypeFilter(this.DataService.Key4) === DataType.Date) {
          formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
        } else {
          formGroupconditions.push((res: any) => res.controls[this.DataService.Key4].value === dataItem[this.DataService.Key4]);
        }
      }
      if (this.DataService.Key5) {
        if (this.getTypeFilter(this.DataService.Key5) === DataType.Date) {
          formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
        } else {
          formGroupconditions.push((res: any) => res.controls[this.DataService.Key5].value === dataItem[this.DataService.Key5]);
        }
      }
      if (this.DataService.Key6) {
        if (this.getTypeFilter(this.DataService.Key6) === DataType.Date) {
          formGroupconditions.push((res: any) => this.CompareBetweenTwoDate(res, dataItem));
        } else {
          formGroupconditions.push((res: any) => res.controls[this.DataService.Key6].value === dataItem[this.DataService.Key6]);
        }
      }
      let formGroupindex = this.formGroups.findIndex((res: any) => formGroupconditions.every(condition => condition(res)));
      this.formGroups[formGroupindex].get(Name)?.patchValue(event.target.checked);
      this.formGroups[formGroupindex].get(Name)?.markAsDirty();
      //change id data
      //let index = this.GridData['data']['data'].findIndex((res: any) => res[this.RowIdentifier] == this.CurrentSelectRow.get(this.RowIdentifier)?.getRawValue());
      let conditions: ((res: any) => boolean)[] = [];
      conditions.push((res: any) => res[this.DataService.Key] === dataItem[this.DataService.Key]);
      if (this.DataService.Key2) {
        conditions.push((res: any) => res[this.DataService.Key2] === dataItem[this.DataService.Key2]);
      }
      if (this.DataService.Key3) {
        conditions.push((res: any) => res[this.DataService.Key3] === dataItem[this.DataService.Key3]);
      }
      if (this.DataService.Key4) {
        conditions.push((res: any) => res[this.DataService.Key4] === dataItem[this.DataService.Key4]);
      }
      if (this.DataService.Key5) {
        conditions.push((res: any) => res[this.DataService.Key5] === dataItem[this.DataService.Key5]);
      }
      if (this.DataService.Key6) {
        conditions.push((res: any) => res[this.DataService.Key6] === dataItem[this.DataService.Key6]);
      }
      let index = this.GridData['data']['data'].findIndex((res: any) => conditions.every(condition => condition(res)));
      this.GridData['data']['data'][index][Name] = event.target.checked;
    } else {
      event.target.checked = event.target.checked ? false : true;
      this.alertShow(this.translateService.instant("Savependingchanges"), 1);
    }
  }
  changeCheckAll(event: any, Name: string) {
    this.beforeCheckAll.emit(event.target.checked)

    this.formGroups.forEach((form, index) => {
      form.get(this.ChangeSet_Status)?.patchValue(StatusAction.UPDATE);
      form.get(Name)?.patchValue(event.target.checked);
      this.GridData['data']['data'][index][Name] = event.target.checked;
    })
    this.ChangeAllCheckBoxes.emit(event.target.checked)

  }
  bindingData(event: any, name: string) {
    if (event instanceof Date) {
      event = new Date(event.toLocaleString());
    }
    if (event?.target) this.getFormGroup(this.RowID).patchValue({ [name]: (event.target.value || event.target.value === 0) ? (event.target.type === "number" ? +event.target.value : event.target.value) : null });
    else if (event) {
      this.getFormGroup(this.RowID).patchValue({ [name]: event });
    }
    this.setDefaultDate(this.getFormGroup(this.RowID));
  }

  createFormGroup(args?: CreateFormGroupArgs | any): FormGroup {
    this.rowIndex = args?.rowIndex;
    this.RowID = args?.dataItem?.[this.RowIdentifier] ? args.dataItem[this.RowIdentifier] : this.RowID;
    this.dataItemReset = { ...args?.dataItem };
    return this.getFormGroup(this.RowID);
  }

  public GetGridData() {
    this.GridData = this.DataService;
    this.GridDataSubscription = this.GridData.subscribe((res: any) => {
      this.totalDataLength = res.total;
      this.RowCount = res.total;
      this.data = res;
      if (this.Mygrid && this.data && this.data.total > 0) {
        this.InitReactiveFormData();
        //  if (!this.rowIndex) {
        this.resetRowIndex = 0;
        // }
        if (this.formGroups.length) {
          this.Mygrid.editCell(
            0,
            0, this.formGroups[0]
          );
          this.CurrentSelectRow = this.formGroups[0];
          if (this.formGroups[0]){
            this.RowID = this.formGroups[0].controls[this.RowIdentifier].value;
            this.OverviewDataBindingSubscribtion(this.RowID);
          }
          this.RowChange.emit();
        }
      }
      else {
        // this.CurrentSelectRow.reset();
        this.formGroups = [];
      }
      this.OnLoadData.emit(null);
    });
  }
  public ClearGrid() {
    this.CurrentSelectRow = this.formBuilder.group(this.form);
    this.formGroups = [];
    this.GridData.data.data = [];
    this.RowID = (null as any);
  }
  OverviewDataBindingSubscribtion(RowID: string) {
    this.RowSubscription?.unsubscribe();
    this.RowSubscription = this.getFormGroup(RowID)?.valueChanges.subscribe((res: any) => {
      if (this.dataItem && this.dataItem.ChangeSet_Status != StatusAction.ADD) {
        if (RowID && this.getFormGroup(RowID)) {
          Object.assign(this.dataItem, (this.getFormGroup(RowID).getRawValue()));
        }
        else {
          //Object.assign(this.dataItem,(res));
          console.warn("Error: this formgroup is undefined. callStack: OverviewDataBindingSubscribtion> this.getFormGroup(RowID)?.valueChanges.subscribe((res: any)> this.getFormGroup(RowID) undefined")
        }
        // this.cd.detectChanges()
      }
    })
  }

  InitReactiveFormData() {
    this.formGroups = [];
    this.RowSubscription?.unsubscribe();
    this.data['data'].forEach((response: any, index: any) => {
      response[this.RowIdentifier] = this.GetNewRowID();
      let formGroup = this.formBuilder.group(this.form);
      formGroup.patchValue({ ...response });
      Object.keys(formGroup.controls).forEach((name: any) => {
        if (name.includes(".")) formGroup.controls[name].patchValue(this.getValuePipe.get(response, name));
      })
      this.setDefaultDate(formGroup);
      this.formGroups.push(formGroup);
    });
  }

  BeforeActionSave() {
    return BeforeAction.NoSaveImp;
  }

  BeforeActionDelete() {
    return BeforeAction.NoDeleteImp;
  }
  AfterActionSave(): void {
  }
  cellCloseHandler(args: CellCloseEvent) {
    this.prevRow = args.rowIndex;
    const { formGroup, dataItem } = args;
    const controls = formGroup.controls;
    let changesetArray:FormGroup[] = [] 
    changesetArray.push(this.CurrentSelectRow)
    if ((this.IsDirty(changesetArray) && this.CurrentSelectRow.status === 'INVALID') || this.PleventCloseRow) {
      args.preventDefault();
      if (formGroup.getRawValue()[this.ChangeSet_Status] !== "Add" || this.GridData['data']['data'].find((f: any) => f.R_WID == this.RowID)) {
        for (const name in controls) {
          if (Object.prototype.hasOwnProperty.call(controls, name) && controls[name].status === 'INVALID') {
            var colIndex = this.Columns.filter(col => col.IsVisible).findIndex(index => index.Name === name);
            this.Mygrid.editCell(
              args.rowIndex,
              colIndex != -1 ? colIndex : 0, this.getFormGroup(this.RowID)
            );
            break;
          }
        }
      }
    }

    if (formGroup.getRawValue()[this.ChangeSet_Status] !== "Delete")
      this.assignValues(dataItem, formGroup.getRawValue());

    if (this.getFormGroup(dataItem[this.RowIdentifier]))// it means it's deleted and not due to event it's called
    {
      this.dataItem = dataItem;
      this.RowID = dataItem[this.RowIdentifier];
      if (this.getFormGroup(this.RowID)?.dirty &&
        this.getFormGroup(this.RowID)['controls'][this.ChangeSet_Status]['value'] != StatusAction.ADD)
        this.getFormGroup(this.RowID)?.patchValue({ [this.ChangeSet_Status]: StatusAction.UPDATE });
    }
    this.CellClose.emit(args);
  }

  public assignValues(target: any, source: any): void {
    Object.assign(target, source);
  }

  public trackByItem(index: number, item: GridItem): any {
    return item.data;
  }

  CheckPendingChange(): boolean {
    for (var i = 0; i < this.changeSet?.changesetArr.length; i++) {
      if (this.IsDirty(this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[])) {
        return true;
      }
    }
    return false;
  }
  IsDirty(formGroups: FormGroup[]): boolean {
    if (formGroups.find(f => (f.controls[this.ChangeSet_Status]['value'] == StatusAction.UPDATE
      || f.controls[this.ChangeSet_Status]['value'] == StatusAction.ADD
      || f.controls[this.ChangeSet_Status]['value'] == StatusAction.Delete
      || f.dirty))) {
      return true;
    }
    return false;
  }

  IsDirtyAndCheckValid(formGroups: FormGroup[]): boolean {
    if (formGroups.find(f => ((f.controls[this.ChangeSet_Status]['value'] == StatusAction.UPDATE
      || f.controls[this.ChangeSet_Status]['value'] == StatusAction.ADD
      || f.controls[this.ChangeSet_Status].getRawValue() == StatusAction.Delete
      || f.dirty) && f.status !== 'INVALID'))) {
      return true;
    }
    return false;
  }

  public AddRow() {
    if (!this.CheckPendingChange()) {
      this.statusAction = StatusAction.ADD;
      this.closeRow(this.rowIndex)

      this.prevRow = -1;
      let formGroup = this.formBuilder.group(this.form);
      this.RowID = this.GetNewRowID();
      formGroup.patchValue({ ...this.DefaultValue, [this.ChangeSet_Status]: StatusAction.ADD, [this.RowIdentifier]: this.RowID });
      this.setDefaultDate(formGroup);
      this.formGroups.push(formGroup);
      this.CurrentSelectRow = this.getFormGroup(this.RowID);
      this.OnAddRow.emit(null);
      if (this.Mygrid) this.Mygrid?.addRow(this.createFormGroup());// no need for create formgrp

      this.AfterAddRow.emit(null);
      this.OverviewDataBindingSubscribtion(this.RowID);
      this.dataItem = null;
    }
    else {
      this.alertShow(this.translateService.instant('Savependingchanges'), 1);
    }
  }

  public async DeleteRow() {
    if (!(this.CurrentSelectRow?.status === 'VALID' || this.CurrentSelectRow?.status === 'DISABLED')) {
      return
    }
    if (this.GetRowValue()[this.DataService.Key] !== null &&this.GetRowValue()[this.DataService.Key] !== undefined) {
      let ret = await this.BeforeActionDelete();
      this.StopDeleteSubscription?.unsubscribe();
      this.StopDeleteSubscription = this.AllowDelete?.subscribe((res: any) => {
        if (res) {
          if (this.DeleteSubscription)
            this.DeleteSubscription.unsubscribe();
          this.BeforeDeleteRow.emit();
          this.DeleteSubscription = this.DataService.delete(this.HandleParamsApiRequest(this.GetRowValue())).subscribe((res: any) => {
            this.resetRowIndex = 0;
            this.read();
            this.alertShow(`(${this.translateService.instant(this.DataService.Key)}: ${this.GetRowValue()[this.DataService.Key]}) ${this.translateService.instant('RecordedDeletedSuccessfully')}`, 2);

          });
        }
      })
      if (ret === BeforeAction.NoDeleteImp) {
        this.AllowDelete?.next(true);
      }
    } else {
      this.alertShow(this.translateService.instant("selectDelete"), 1);
    }

  };

  insertDataItemInRow(args: any) {
    this.dataItem = args.dataItem;
    this.CurrentSelectRow = this.createFormGroup(args);
    this.CellClick.emit(args);
    args.sender.editCell(
      args.rowIndex,
      args.columnIndex,
      this.createFormGroup(args)
    );
    this.OverviewDataBindingSubscribtion(this.RowID);
  }

  public cellClickHandler(args: CellClickEvent): void {
    if (!this.CheckPendingChange() || this.prevRow == args.rowIndex) {
      this.insertDataItemInRow(args);// setting also rowID and will be separated
      if (this.prevRow != args.rowIndex) {
        // this.CurrentSelectRow = this.getFormGroup(this.RowID);
        this.RowChange.emit(args);
      }

    } else {
      this.mySelection = [this.prevRow];
      this.alertShow(this.translateService.instant("Savependingchanges"), 1);
    }
  }

  set resetRowIndex(rowIndex: number) {
    this.mySelection = [rowIndex];
    this.rowIndex = rowIndex;
  }

  filterByDropList(e: any, filterService: any, Name: string) {
    filterService.filter({
      filters: [{ field: Name, operator: 'eq', value: parseInt(e) }],
      logic: 'and'
    });
  }
private GridDataBeforeFiltering:any;
  onValueChange(e: any) {
    this.DataService.state.skip = e.skip;
    this.DataService.state.sort = e.sort;
    this.resetRowIndex = 0;
    this.filter = toODataString(e);
    this.filter = this.filter.replace("$skip=0", "");
    if(this.DataService.IsClientSideFilter){
      if(!this.GridDataBeforeFiltering){
        this.GridDataBeforeFiltering = this.GridData.data.data;
      }
      this.GridData.data.data = process(this.GridDataBeforeFiltering,e).data;
      return;
    }
    this.SortChanges.emit([...e.sort])
    this.DataService.read(`${this.filter}${this.filter.charAt(this.filter.length - 1) === '&' ? '' : '&'}$skip=${this.DataService.state.skip}&$count=true`);
  }

  ResetRowUpdateStatus() {
    this.statusAction = StatusAction.NOP;
  }

  Cancel() {
    if (this.CurrentSelectRow?.get(this.ChangeSet_Status) && this.CurrentSelectRow?.get(this.ChangeSet_Status)?.getRawValue() !== StatusAction.ADD) {
      this.DataService.get(this.HandleFilterApiRequest(this.CurrentSelectRow.getRawValue())).subscribe((data: any) => {
        const response = data?.value[0] ? data?.value[0] : data;
        this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
          if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
        })
        this.getFormGroup(this.RowID)?.reset({ ...response, [this.ChangeSet_Status]: null, [this.RowIdentifier]: this.RowID });
        let newDataItem = {...this.dataItem};
        Object.keys(this.getFormGroup(this.RowID)?.controls).forEach((name: any) => {
          if (name.includes(".")) this.getFormGroup(this.RowID)?.controls[name].patchValue(this.getValuePipe.get(response, name));
          newDataItem[name] = this.getFormGroup(this.RowID)?.controls[name].getRawValue();
        });
        /// Update Checkbox from API data ///
        if (this.checkboxColumnIndexLastChanged > -1) {
          let args = {
            dataItem: newDataItem,
            sender: this.Mygrid,
            rowIndex: this.rowIndex,
            columnIndex: this.checkboxColumnIndexLastChanged
          };
          this.insertDataItemInRow(args)
          this.checkboxColumnIndexLastChanged = -1;
        }

        this.CurrentSelectRow = this.getFormGroup(this.RowID);
        for (var i = 1; i < this.changeSet.changesetArr.length; i++) {
          if (this.changeSet.changesetArr[i].Grid != this)
            this.changeSet.changesetArr[i].Grid.Cancel();
        }
        this.AfterCancel.emit(null);
      })
    } else {
      this.formGroups = this.formGroups.filter(f => f.controls[this.RowIdentifier].value !== this.RowID);
      this.RowID = '';
      for (var i = 1; i < this.changeSet.changesetArr.length; i++) {
        if (this.changeSet.changesetArr[i].Grid != this)
          this.changeSet.changesetArr[i].Grid.Cancel();
      }
      // this.read();
      this.CurrentSelectRow = this.formGroups[0];
    }
    this.closeRow()
    this.ResetRowUpdateStatus();
  }

  alertShow(content: string, type: number) {
    this.loggerService.Content = this.translateService.instant(content);
    this.loggerService.Type = type;
    this.loggerService.Show();
  }

  ValidateDirtyBeforeSave(formgroups: FormGroup[]) {
    formgroups.forEach(f => {
      if (f.get(this.ChangeSet_Status)?.value == null && f.dirty) {
        f.patchValue({ [this.ChangeSet_Status]: StatusAction.UPDATE });
      }
    });
  }


  PrepareBodyReq(data: any) {
    if (this.DataService.excludeDataFromReq.length) {
      this.DataService.excludeDataFromReq.forEach((res: any) => delete data[res])
    };
    if(this.DataService.excludeTimeFromReq.length){
      this.DataService.excludeTimeFromReq.forEach((res: any) => {
        if(data[res])
          data[res] = this.datePipe.transform(data[res],'yyyy-MM-dd')
    })
    }
    return data;
  }

  getTypeFilter(Key: string) {
    return this.DataService.Columns.find((f: { Name: string; DataType: DataType; }) => f.Name == Key)?.DataType;
  }

  HandleFilterApiRequest(response: any) {
    return (this.DataService.APIURL
      + (!this.DataService.APIURL.includes('?') ? '?' : '')
      + (this.DataService.APIURL.includes('filter') ? ' and ' : '&$filter=') + `${this.DataService.Key} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key, response)}`
      + (this.DataService.Key2 ? ` and ${this.DataService.Key2} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key2, response)}` : '')
      + (this.DataService.Key3 ? ` and ${this.DataService.Key3} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key3, response)}` : '')
      + (this.DataService.Key4 ? ` and ${this.DataService.Key4} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key4, response)}` : '')
      + (this.DataService.Key5 ? ` and ${this.DataService.Key5} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key5, response)}` : '')
      + (this.DataService.Key6 ? ` and ${this.DataService.Key6} eq ${this.HandleFormateTypeKeysReq(this.DataService.Key6, response)}` : ''))
  }

  HandleFormateTypeKeysReq(Key: string, Value: any) {
    if (this.getTypeFilter(Key) === DataType.Date) {
      return new Date(Value[Key]).getFullYear() + "-" + (new Date(Value[Key]).getMonth() + 1) + "-" + new Date(Value[Key]).getDate();
    } else if (this.getTypeFilter(Key) === DataType.Text) {
      return "'" + Value[Key] + "'";
    }
    return Value[Key];
  }


  HandleParamsApiRequest(Value: any): string {
    // if have more than one key
    if (this.DataService.Key && this.DataService.Key2) {
      return (
        `${this.DataService.Key}=${this.HandleFormateTypeKeysReq(this.DataService.Key, Value)}`
        + (this.DataService.Key2 ? `,${this.DataService.Key2}=${this.HandleFormateTypeKeysReq(this.DataService.Key2, Value)}` : '')
        + (this.DataService.Key3 ? `,${this.DataService.Key3}=${this.HandleFormateTypeKeysReq(this.DataService.Key3, Value)}` : '')
        + (this.DataService.Key4 ? `,${this.DataService.Key4}=${this.HandleFormateTypeKeysReq(this.DataService.Key4, Value)}` : '')
        + (this.DataService.Key5 ? `,${this.DataService.Key5}=${this.HandleFormateTypeKeysReq(this.DataService.Key5, Value)}` : '')
        + (this.DataService.Key6 ? `,${this.DataService.Key6}=${this.HandleFormateTypeKeysReq(this.DataService.Key6, Value)}` : ''))
    }
    return Value[this.DataService.Key]
  }

  DoAdd() {
    if (this.getFormGroup(this.RowID)?.status === 'VALID' || this.getFormGroup(this.RowID)?.status === 'DISABLED')// why don't use currentselectedrow
    {
      this.ConvertBoolean2Number();
      let value = this.PrepareBodyReq({ ...this.getFormGroup(this.RowID).getRawValue() });

      delete value[this.ChangeSet_Status];
      delete value[this.RowIdentifier];
      this.AddSubscription = this.DataService.add(value).pipe(switchMap((res: any) => {
        return (this.DataService.get(this.HandleFilterApiRequest(res)))
      })).subscribe((data: any) => {
        const response = data?.value[0] ? data?.value[0] : data;
        this.filter = '';
        if (!this.data?.data)
          this.data['data'] = [];
        this.data['data'].unshift({ ...response });

         this.totalDataLength = this.totalDataLength + 1;

        this.RowCount++;
        this.alertShow(this.translateService.instant("SavedSuccessfully"), 2);
        this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
          if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
        })
        this.getFormGroup(this.RowID)?.patchValue({ ...response, [this.ChangeSet_Status]: null, [this.RowIdentifier]: this.RowID });
        Object.keys(this.getFormGroup(this.RowID)?.controls).forEach((name: any) => {
          if (name.includes(".")) this.getFormGroup(this.RowID)?.controls[name].patchValue(this.getValuePipe.get(response, name));
        })
        this.closeRow();
        this.OverviewDataBindingSubscribtion(this.RowID);
        if (this.Mygrid && this.getFormGroup(this.RowID)) {
          // if (!this.rowIndex) {
          this.resetRowIndex = 0;
          // }
          this.Mygrid.editCell(
            this.rowIndex,
            0, this.getFormGroup(this.RowID)
          );
          this.getFormGroup(this.RowID).markAsPristine();
        }
        this.ResetRowUpdateStatus();
        this.saveAll();
        this.AfterAdd.emit(response);
      })
    };
  }
  public GetUpdatedProperties(myForm: FormGroup<any> | undefined): any {
    const updatedControls = [];
    let updatedProp: any = {}
    if (!myForm)
      return null
    for (const controlName in myForm.controls) {
      if (myForm.get(controlName) && !myForm.get(controlName)?.pristine) {
        updatedControls.push(controlName);
        updatedProp[controlName] = myForm.get(controlName)?.getRawValue();
      }
    }
    return updatedProp;
  }

  DoUpdate() {
    if (this.getFormGroup(this.RowID)?.status === 'VALID' || this.getFormGroup(this.RowID)?.status === 'DISABLED') {
      this.ConvertBoolean2Number();

      // TODO: remove any formGroups.find and replace with CurrentSelectRow, example the below line.
      // let formUpdate = this.CurrentSelectRow;

      let formUpdate = this.formGroups.find(data => data.get(this.ChangeSet_Status)?.value === StatusAction.UPDATE); // why not using currentselectedrow

      if (!formUpdate) {
        this.ValidateDirtyBeforeSave(this.formGroups);
        formUpdate = this.formGroups.find(data => data.get(this.ChangeSet_Status)?.value === StatusAction.UPDATE); // why not using currentselectedrow
      }

      const value = this.PrepareBodyReq({ ...formUpdate?.getRawValue() })
      delete value?.[this.ChangeSet_Status];
      delete value?.[this.RowIdentifier];


      let save$: Observable<any>;
        const updatedvalue = this.PrepareBodyReq(this.GetUpdatedProperties(formUpdate));
        delete updatedvalue?.[this.ChangeSet_Status];
        delete updatedvalue?.[this.RowIdentifier];
        save$ = this.DataService.patch(updatedvalue, this.HandleParamsApiRequest(value))

      if (this.EditSaveSubscription)
        this.EditSaveSubscription.unsubscribe();
      this.EditSaveSubscription = save$
        .pipe(switchMap((res: any) => {
          return (this.DataService.get(this.HandleFilterApiRequest(this.CurrentSelectRow.getRawValue())))
        }))
        .subscribe((data: any) => {
          const response = data?.value[0];
          this.filter = '';
          this.alertShow(this.translateService.instant("SavedSuccessfully"), 2);
          this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
            if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
          })
          this.CurrentSelectRow?.reset({ ...response, [this.ChangeSet_Status]: null, [this.RowIdentifier]: this.RowID });
          Object.keys(this.getFormGroup(this.RowID)?.controls).forEach((name: any) => {
            if (name.includes(".")) this.getFormGroup(this.RowID)?.controls[name].patchValue(this.getValuePipe.get(response, name));
          })
          this.closeRow(this.rowIndex);
          //  this.resetRowIndex = 0;// reset the row idx after save
          this.filter = '';
          //  this.read();
          //this.getFormGroup(this.RowID).reset();// no need as it's done from sub in griddata
          this.AfterSave.emit();
          this.saveAll();

        });
    };
  }
  public async SaveWithoutConfirmation() {
    await this.ValidateDirtyBeforeSave(this.formGroups);
    await this.BeforeActionSave();


    if (!this.IsDirty(this.formGroups)) {
      this.saveAll();
    }
    else if (this.getFormGroup(this.RowID).get(this.ChangeSet_Status)?.value === StatusAction.ADD) {
      // Save Create
      this.DoAdd();
    } else {
      // Save Update
      this.DoUpdate();
    };


  }

  getDisplayName(fieldName : string) {
    return this.Columns?.find(c => c.Name == fieldName)?.DisplayName
  }

  public async Save() {
    await this.ValidateDirtyBeforeSave(this.formGroups);

    this.StopSaveSubscription?.unsubscribe();
    this.StopSaveSubscription = this.AllowSave?.subscribe((res: any) => {
      if (res) {
        this.errorDetailsService.ErrorMessagesQueue = [];
        let AllInvalid = this.changeSet.changesetArr.filter((x) => x.Grid.formGroups.find((y) => y.status == 'INVALID'
          && (y.dirty == true || y.controls[this.ChangeSet_Status].value == StatusAction.ADD
            || y.controls[this.ChangeSet_Status].value == StatusAction.UPDATE)))

        if (AllInvalid.length > 0) {
          AllInvalid.forEach(change => {
            let currentFG = change.Grid.formGroups.find((y) => y.status == 'INVALID'
              && (y.dirty == true || y.controls[this.ChangeSet_Status].value == StatusAction.ADD
                || y.controls[this.ChangeSet_Status].value == StatusAction.UPDATE))

            change.Grid.DataService.Columns.forEach((res: any) => {
              if (currentFG?.controls[res.Name]?.status == "INVALID") {
                var displayName = this.getDisplayName(res.Name) || res.Name
                this.errorDetailsService.PushErrorMessages({
                  Title: this.translateService.instant(displayName) + " " + this.translateService.instant('IsInvalid'),
                  Details: this.translateService.instant(displayName) + " " + this.translateService.instant('IsInvalid'),
                  Id: 0,
                  Type: 0
                });
                ////
              }
            });

          })
          return;

        }
        if (!this.IsDirty(this.formGroups)) {
          this.saveAll();
        }
        else if (this.getFormGroup(this.RowID).get(this.ChangeSet_Status)?.value === StatusAction.ADD) {
          // Save Create
          this.DoAdd();
        } else {
          // Save Update
          this.DoUpdate();
        };
      }
    });
    let ret = await this.BeforeActionSave();
    if (ret === BeforeAction.NoSaveImp) {
      this.AllowSave.next(true);
    }
  }
  CompearObjectByKey(keys: any[], obj1: any, obj2: any) {
    let IsMatch = true;
    keys.map((key) => {
      IsMatch = (obj1[key] === obj2[key]) && IsMatch
    })
    return IsMatch
  }
  PrepareInsertedITems(CreatedItemArray: Array<FormGroup<any>>, excludeDataFromReq: Array<string>): Array<any> {
    let body: Array<any> = []
    CreatedItemArray.forEach(createdItem => {
      let currentItem = createdItem.getRawValue();
      excludeDataFromReq.forEach((res: any) => delete currentItem[res])
      body.push(currentItem);

    })
    return body;
  }
  PrepareUpdatedITems(updatedtemArray: Array<FormGroup<any>>, excludeDataFromReq: Array<string>): Array<any> {
    let body: Array<any> = []
    updatedtemArray.forEach(updatedItem => {
      // let currentItem=updatedItem.getRawValue();
      let currentItem = this.GetUpdatedProperties(updatedItem)
      excludeDataFromReq.forEach((res: any) => delete currentItem[res])
      body.push(currentItem);

    })
    return body;
  }
  PrepareDeletedITems(DeletedArray: Array<FormGroup<any>>): Array<any> {
    let body: Array<any> = []
    DeletedArray.forEach(deletedITem => {
      let currentItem = deletedITem.getRawValue();
      body.push(currentItem);

    })
    return body;
  }
  async saveAll() {
    var SavedSuccessfullyMsg = this.translateService.instant('SavedsuccessufellyKey');



    for (var index = 0; index < this.changeSet.changesetArr.length; index++) {

      if (index == 0 && this.IsHeader==true) {
        continue;
      }
      if (this.IsDirtyAndCheckValid(this.changeSet.changesetArr[index].Grid.formGroups as FormGroup[])) {
        //await this.changeSet.changesetArr[index].Grid.Save();
        let myfg = this.changeSet.changesetArr[index].Grid.formGroups
        await this.ValidateDirtyBeforeSave(myfg as FormGroup[]);

        (function (_this, i, _SavedSuccessfullyMsg) {
          if (!(_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq as Array<string>).find((ex) => ex == _this.RowIdentifier))
            _this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq.push(_this.RowIdentifier);
          if (!(_this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq as Array<string>).find((ex) => ex == _this.ChangeSet_Status))
            _this.changeSet.changesetArr[i].Grid.DataService.excludeDataFromReq.push(_this.ChangeSet_Status);
          var addedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(c => c.controls[_this.ChangeSet_Status]['value'] == 'Add' && c.status == "VALID");
          var updatedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(u => u.controls[_this.ChangeSet_Status]['value'] == 'Update');
          var deletedArray = (_this.changeSet.changesetArr[i].Grid.formGroups as FormGroup[]).filter(d => d.controls[_this.ChangeSet_Status]['value'] == 'Delete')
          if ((addedArray.length + updatedArray.length + deletedArray.length) > 1000) {
            _this.alertShow(_this.translateService.instant("CantSaveMoreThan100AtOnce"), 0);
          }
          else if (addedArray.length > 0 || updatedArray.length > 0 || deletedArray.length > 0) {
            _this.changeSet.changesetArr[i].Grid.closeRow();
            _this.changeSet.changesetArr[i].Grid.ConvertBoolean2Number()
            _this.changeSet.changesetArr[i].Grid.DataService.batch(
              addedArray
              , updatedArray,
              deletedArray
            )
              .subscribe((response: any) => {
                const statusSuccess = response?.responses.filter((res: any) => res['status'] >= 200 && res['status'] < 300)
                const statusFalid = response?.responses.filter((res: any) => res['status'] > 300);
                if (statusSuccess?.length && !statusFalid?.length) {
                  _this.alertShow(_SavedSuccessfullyMsg, 2)
                  _this.AfterActionSave();
                }

                if (statusFalid.length) {
                  statusSuccess.forEach((element: any) => {
                    (_this.changeSet.changesetArr[i].Grid).formGroups.filter(formGroup => {
                      if (formGroup.controls[_this.RowIdentifier].value === element.id) {
                        formGroup.get(_this.ChangeSet_Status)?.patchValue(StatusAction.NOP);
                      }
                    });
                  });

                  statusFalid.forEach((element: any) => {
                    // _this.alertShow(element.body.error.message.value, 0);
                    _this.errorDetailsService.PushErrorMessages({
                      Title: element.body.error.message.value,
                      Details: element.body.innerError.trace,
                      Id: 0,
                      Type: 0
                    });
                    let gridData: any = _this.changeSet.changesetArr[i].Grid
                    let AddedFormGroup = (_this.changeSet.changesetArr[i].Grid).formGroups
                      .filter((from) => { return from.controls[_this.RowIdentifier].value === gridData.RowID })[0]?.getRawValue();


                    if (AddedFormGroup && !gridData?.data?.data.
                      find((res: any) => res[_this.RowIdentifier] == gridData.RowID))
                      (gridData).data?.data.unshift(AddedFormGroup);
                  });
                }
                if (!statusFalid?.length) {
                  _this.changeSet.changesetArr[i].Grid.read();
                }
                /* _this.changeSet.changesetArr[i].Grid.formGroups.forEach((form: any) => {
                   form.reset();
                 })*/
              });
          }
          else {
            _this.alertShow(_this.translateService.instant("noValidDataToSave"), 0);
            // let gridData: any = _this.changeSet.changesetArr[i].Grid
            // let AddedFormGroup = (_this.changeSet.changesetArr[i].Grid).formGroups
            //   .filter((from: any) => { return from.controls[_this.RowIdentifier].value === gridData.RowID })[0]?.getRawValue();
            // if (AddedFormGroup && !gridData?.data?.data.
            //   find((res: any) => res[_this.RowIdentifier] == gridData.RowID))
            //   (gridData).data?.data.unshift(AddedFormGroup);
            // _this.changeSet.changesetArr[i].Grid.DataService.read();
            /*  _this.changeSet.changesetArr[i].Grid.formGroups.forEach((form: any) => {
                form.reset();
              })*/
          }

        })(this, index, SavedSuccessfullyMsg);
      }
    }
  }

  closeRow(rowIndex?: number) {
    this.OnCloseRow.emit(null);
    this.Mygrid.closeRow(rowIndex);
  }

  public onPageChange(e: PageChangeEvent): void {
    if (!this.CheckPendingChange()) {
      this.changePage(e);
    } else {
      this.alertShow("Save pending changes", 1);
    }
  }
  public changePage(e: PageChangeEvent){
    this.DataService.state.skip = e.skip;
    this.resetRowIndex = 0;
    this.read();
  }

  GetDropDownTxtValueByCode(code: any, dropDownTemplet: any) {//              key?:string, list?: any []  ){
    let displayedTxt;
    if (dropDownTemplet.list) {
      let LisItem = dropDownTemplet.list.find((x: { [x: string]: any; }) => x[dropDownTemplet.value] == code)
      if (LisItem)
        displayedTxt = LisItem[dropDownTemplet.text]
    }
    return displayedTxt ? displayedTxt : 'none';
  }

  handleDate(date: Date | any) {
    return (date ? new Date(date) : date);
  }
  setDefaultDate(form: any) {
    const dateColumns = this.Columns.filter((res) => res.DataType === DataType.Date);
    dateColumns.map((res) => {
      if (form.controls?.[res.Name]?.value !== null && form.controls?.[res.Name]?.value !== undefined) {
        const dateValue = form.controls?.[res.Name]?.value as string;
        form.controls?.[res.Name]?.patchValue(new Date(dateValue))
      }
      else {
         form.controls?.[res.Name].patchValue(null);
      }
    })
  }

  updateCurrentSelectedRow(data: any) {
    this.Columns.forEach((res) => {
      if (res.DataType === DataType.Date && this.CurrentSelectRow.controls?.[res.Name]) {
        if (data.controls?.[res.Name].value !== null) {
          this.CurrentSelectRow.controls?.[res.Name].patchValue(new Date(data[res.Name]))
        } else {
          //this.CurrentSelectRow.controls?.[res.Name].patchValue(new Date(''));
        }
      } else if (this.CurrentSelectRow.controls?.[res.Name]) {
        this.CurrentSelectRow.controls?.[res.Name].patchValue(data[res.Name])
      };
    });
  }
  ngOnDestroy(): void {
    this.GridDataSubscription?.unsubscribe();
    this.RowSubscription?.unsubscribe();
    this.StopDeleteSubscription?.unsubscribe();
    this.StopAddSubscription?.unsubscribe();
    this.StopSaveSubscription?.unsubscribe();
    this.DeleteSubscription?.unsubscribe();
    this.AddSubscription?.unsubscribe();
    this.EditSaveSubscription?.unsubscribe();
    this.setPreventCloseRowSubscription?.unsubscribe();
    if (this.changeSet?.changesetArr?.findIndex((res: any) => res.Grid?.GridID == this.GridID) >= 0)
      this.changeSet.changesetArr.splice(this.changeSet.changesetArr.findIndex((res: any) => res.Grid?.GridID == this.GridID), 1)
  }
  PleventCloseRow: boolean = false;
  setPreventCloseRow = new BehaviorSubject<boolean>(false);
  setPreventCloseRowSubscription = this.setPreventCloseRow.subscribe((value) => {
    this.PleventCloseRow = value;
  });
  public Kendofilter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  };
  public filterChange(filter: CompositeFilterDescriptor): void {
    this.Kendofilter = filter;
  }

  GetDropDownStatusColorByCode(code: any, dropDownTemplet: any) {
    let color;
    if (dropDownTemplet.list) {
      let LisItem = dropDownTemplet.list.find((x: { [x: string]: any; }) => x[dropDownTemplet.value] == code)
      if (LisItem)
        color = LisItem.StatusColor
    }
    return color ? color : '#00000';
  }

  RefreshCurrentRow(AfterRefreshFunc: Function) {
    return this.DataService.get(this.HandleFilterApiRequest(this.CurrentSelectRow.getRawValue()))
      .subscribe((data: any) => {
        const response = data?.value[0];
        this.filter = '';
        this.Columns.filter((res) => res.DataType === DataType.Date).map((res) => {
          if (response[res.Name]) response[res.Name] = new Date(response[res.Name]);
        })
        this.CurrentSelectRow?.reset({ ...response, [this.ChangeSet_Status]: null, [this.RowIdentifier]: this.RowID });
        Object.keys(this.CurrentSelectRow?.controls).forEach((name: any) => {
          if (name.includes(".")) this.CurrentSelectRow?.controls[name].patchValue(this.getValuePipe.get(response, name));
        });
        this.filter = '';
        if (AfterRefreshFunc) AfterRefreshFunc();
      })

  }


  // dialog
  public opened = '';
  public DialogText!: string;

  public close(status: string): void {
    this.opened = '';
  }

  public open(event: any, res: any, data: any): void {
    let currentSelectedItem = res.Name;

    // Beautify the JSON if it exists in the data
    if (data[currentSelectedItem] && currentSelectedItem == "JSONDATA") {
        const jsonData = data[currentSelectedItem];
        if (jsonData) {
            const jsonObject = JSON.parse(jsonData);
            const beautifiedJson = JSON.stringify(jsonObject, null, 2);

            data[currentSelectedItem] = beautifiedJson;
        }
    }

    // Add linebreaks if it is HTML
    let content = data[currentSelectedItem];
    if (content && content.trim().startsWith('<')) {
        content = content
            .replace(/>\s*</g, '>\n<')
            .replace(/\n\s*\n/g, '\n')
            .replace(/^\s*\n/g, '')
            .replace(/\n\s*$/g, '');

        data[currentSelectedItem] = content.trim();
    }

    this.DialogText = data[currentSelectedItem];
    this.opened = data[this.RowIdentifier];
}

public openDialog(event: any, res: any, data: any): void {
  this.open(event,res,data);
  this.openPopUpDialog.openDialog()

}


  getvalidateLookupValueCheckExistence(flagVal: boolean | undefined) {
    return flagVal == undefined ? true : flagVal;
  }



  public EnableDisable_columns(colmnNames: string[], IsEditable: boolean): void {
    if (IsEditable) {
      colmnNames.forEach(columnName => {
        //this.CurrentSelectRow?.get(columnName)?.enable({ emitEvent: false });
        this.CurrentSelectRow?.controls[columnName]?.enable({ emitEvent: false });
      });
    } else {
      colmnNames.forEach(columnName => {
        //this.CurrentSelectRow?.get(columnName)?.disable({ emitEvent: false });
        this.CurrentSelectRow?.controls[columnName]?.disable({ emitEvent: false });
      });
    }
    this.Columns = this.Columns.filter(res => {
      if (colmnNames.includes(res.Name)) {
        res.IsEditable = IsEditable;
      }
      return res;
    })
  }

  public GetCurrentSelectRow_ChangeSetStatus(): string {
    return this.CurrentSelectRow?.get(this.ChangeSet_Status)?.getRawValue();
  }

  public SetValue(ColumnName: string, Value: any, MarkAsDirty: boolean = true): void {
    //this.CurrentSelectRow.get(ColumnName)?.patchValue(Value);
    this.CurrentSelectRow.controls[ColumnName].patchValue(Value);
    if (MarkAsDirty) {
      this.CurrentSelectRow.markAsDirty();
      this.CurrentSelectRow.get(ColumnName)?.markAsDirty();
      //this.CurrentSelectRow.get(ColumnName).markAsDirty();
    }
  }
  public GetRowValue(): any {
    return this.CurrentSelectRow.getRawValue();
  }

  public GetValueOf(Name: string): any {
    return this.CurrentSelectRow.get(Name)?.getRawValue();
  }

  public goToPage(pPage?: string, id?: string) {
    // this.router.navigate('')
    if (pPage) {
      if (!this.CheckPendingChange()) {
        this.router.navigate([pPage, id]);
      }
      else {
        this.alertShow(this.translateService.instant('Savependingchanges'), 1);
      }
    }
  }
  ConvertBoolean2Number() {
    var boolean = this.Columns.filter(x => x.IsNumber2Boolean == true).map(x => x.Name);
    if (this.CurrentSelectRow) {
      boolean.forEach((column) => {
        this.CurrentSelectRow.controls[column].patchValue(
          +this.CurrentSelectRow?.get(column)?.getRawValue()
        )
      });
    }
  }
  public setFilter(fieldName: string, value: string, type: DataType) {
    let _filter: FilterDescriptor = { field: fieldName, operator: "eq", value: value };
    let _gridFilter: CompositeFilterDescriptor = { filters: [], logic: "and" };
    _gridFilter.filters = [_filter]
    if (type == "numeric")
    this.filter = "$filter=" + fieldName + " eq " + value + "";
    else
    this.filter = "$filter=" + fieldName + " eq '" + value + "'";

    this.Kendofilter = _gridFilter;
  }
  public ExportToExcel(): void {
    this.Mygrid.saveAsExcel();
  }

  public ResetFilters() {
    this.filter = '';
    this.Kendofilter =  {
      logic: 'and',
      filters: [],
    };
  }

  ShowDialog(domid: string){
    this.customizeColumnsDialog
    .ShowDialog(
      BIGridColumnCustomizerComponent, 
      {component: this, domid: this.DomID, columns: this.Columns},
      this.translateService.instant("CustomizeColumns"),
      this.translateService.instant("Ok") ,
      this.translateService.instant("SetAsDefault"), 
      true, 
      true 
    )
  }
}
